import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="bg-[#FFF8F5] py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF7043] mb-2">Siamo qui per te</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-slate-900">
            Contattaci
          </h1>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-xl shadow-slate-100/50">
            <h2 className="font-heading text-2xl font-bold text-slate-900 mb-6">Informazioni</h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#FF7043]/10 flex items-center justify-center shrink-0">
                  <Phone size={20} className="text-[#FF7043]" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-slate-900">Telefono</p>
                  <a href="tel:3801599564" className="text-slate-500 hover:text-[#FF7043] transition-colors" data-testid="contact-phone">
                    380 159 9564
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#0288D1]/10 flex items-center justify-center shrink-0">
                  <Mail size={20} className="text-[#0288D1]" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-slate-900">Email</p>
                  <a href="mailto:caribbeanbluemoon2025@gmail.com" className="text-slate-500 hover:text-[#0288D1] transition-colors break-all" data-testid="contact-email">
                    caribbeanbluemoon2025@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center shrink-0">
                  <Clock size={20} className="text-green-600" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-slate-900">Orari</p>
                  <p className="text-slate-500 font-bold" data-testid="contact-hours">Aperti H24</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Card */}
          <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-xl shadow-slate-100/50 flex flex-col items-center justify-center text-center">
            <p className="font-accent text-4xl text-[#FF7043] mb-4">La danza unisce</p>
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-4">
              Vieni a trovarci!
            </h3>
            <p className="text-slate-500 leading-relaxed mb-6">
              La tua prima lezione è sempre <span className="font-bold text-green-600">gratuita</span>. 
              Non perdere l'occasione di scoprire la gioia della danza con noi!
            </p>
            <a
              href="tel:3801599564"
              data-testid="contact-call-btn"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#FF7043] text-white font-heading font-bold rounded-full btn-caribbean"
            >
              <Phone size={18} /> Chiamaci Ora
            </a>
          </div>
        </div>

        {/* 3 Locations */}
        <div className="mt-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900 mb-8 text-center">
            Le Nostre <span className="text-[#0288D1]">Sedi</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Sede Principale */}
            <div className="bg-white rounded-3xl p-6 border-2 border-[#FF7043] shadow-xl shadow-orange-100/50 text-center" data-testid="location-grosseto">
              <div className="w-12 h-12 rounded-full bg-[#FF7043]/10 flex items-center justify-center mx-auto mb-4">
                <MapPin size={24} className="text-[#FF7043]" />
              </div>
              <span className="inline-block px-3 py-1 bg-[#FF7043] text-white text-xs font-bold rounded-full mb-3">
                Sede Principale
              </span>
              <h3 className="font-heading font-bold text-lg text-slate-900 mb-2">Grosseto</h3>
              <p className="text-slate-500 text-sm">Via Ambra 19, 58100 Grosseto</p>
            </div>

            {/* Follonica */}
            <div className="bg-white rounded-3xl p-6 border border-slate-100 shadow-xl shadow-slate-100/50 text-center" data-testid="location-follonica">
              <div className="w-12 h-12 rounded-full bg-[#0288D1]/10 flex items-center justify-center mx-auto mb-4">
                <MapPin size={24} className="text-[#0288D1]" />
              </div>
              <h3 className="font-heading font-bold text-lg text-slate-900 mb-2">Follonica</h3>
              <p className="text-slate-500 text-sm">Presso Palestra Altroquando</p>
            </div>

            {/* Abbadia */}
            <div className="bg-white rounded-3xl p-6 border border-slate-100 shadow-xl shadow-slate-100/50 text-center" data-testid="location-abbadia">
              <div className="w-12 h-12 rounded-full bg-[#FFCA28]/20 flex items-center justify-center mx-auto mb-4">
                <MapPin size={24} className="text-[#FF7043]" />
              </div>
              <h3 className="font-heading font-bold text-lg text-slate-900 mb-2">Abbadia San Salvatore</h3>
              <p className="text-slate-500 text-sm">Presso Palestra Hatena</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
